import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  state: () => {
    return {
      aboutDialog: false,
      userProfileDialog: false,
      svgUploadDialog: false,
      activityDataExportDialog: false,
      activityDataImportDialog: false,
      activitySettingsDialog: false,
    }
  },

  actions: {},
})
